import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getIsAuth = async () => {
  const { data } = await supabase.auth.getSession()
  return data?.session?.user || null
}

export default function useIsAuth() {
  const data = useQuery({
    queryKey: ['isAuth'],
    queryFn: getIsAuth,
    staleTime: 60000,
    refetchOnMount: true,
  })
  return {
    ...data,
    data: {
      isAuth: Boolean(data?.data?.id),
      user: data?.data,
    },
  }
}
